window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  this.initializedContainers = new WeakSet();
  this.deferredObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(
              function (entry) {
                if (!entry.isIntersecting) return;

                this.deferredObserver.unobserve(entry.target);
                this._createInstance(entry.target);
              }.bind(this)
            );
          }.bind(this),
          { rootMargin: "700px 0px" }
        )
      : null;

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    if (this.initializedContainers.has(container)) {
      return;
    }

    if (this.deferredObserver) {
      this.deferredObserver.unobserve(container);
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.initializedContainers.add(container);
    this.instances.push(instance);
  },

  _getInstance: function (sectionId) {
    var instance = this.instances.find(function (item) {
      return item.id === sectionId;
    });

    if (typeof instance === "undefined") {
      var container = document.querySelector(
        '[data-section-id="' + sectionId + '"]'
      );

      if (container) {
        this._createInstance(container);
        instance = this.instances.find(function (item) {
          return item.id === sectionId;
        });
      }
    }

    return instance;
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container && this.deferredObserver) {
      this.deferredObserver.unobserve(container);
    }

    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    var instance = this._getInstance(evt.detail.sectionId);

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = this._getInstance(evt.detail.sectionId);

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = this._getInstance(evt.detail.sectionId);

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = this._getInstance(evt.detail.sectionId);

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor, deferUntilVisible) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        if (deferUntilVisible && this.deferredObserver) {
          this.deferredObserver.observe(container);
        } else {
          this._createInstance(container, constructor);
        }
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    if (e.dataset.sliderEnable !== "true") return;

    const sliderContainer = e.querySelector(".productSlider"),
      extraLargeDesktopShow = Number.parseInt(e.dataset.showExtraLarge, 10),
      mobileShow = Number.parseInt(e.dataset.showMobile, 10),
      sliderAutoplay = e.dataset.autoplay === "true",
      autoPlayTime = Number.parseInt(e.dataset.autoplayTime, 10),
      autoPlayValue = sliderAutoplay ? { delay: autoPlayTime } : false;

    var featuredCollection = new Swiper(sliderContainer, {
      loop: e.dataset.sliderLoop === undefined || e.dataset.sliderLoop.trim() === "true",
      slidesPerView: mobileShow,
      spaceBetween: 30,
      autoplay: autoPlayValue,
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
        type: "fraction"
      },
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });

    if (sliderAutoplay) {
      sliderContainer.addEventListener('mouseenter', (e) => {
        featuredCollection.autoplay.stop();
      });
      sliderContainer.addEventListener('mouseleave', (e) => {
        featuredCollection.autoplay.start();
      });
    }  
  }
  return sliderProduct;
})();

// ------------- 

// =========

document.addEventListener("DOMContentLoaded", function () {
  if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
    document.addEventListener("pointerover", function (event) {
      const productCard = event.target.closest(".product-grid-item");
      if (!productCard || productCard.contains(event.relatedTarget)) return;

      const secondaryImage = productCard.querySelector(
        ".secondary__img[data-srcset]"
      );
      if (!secondaryImage) return;

      secondaryImage.addEventListener(
        "load",
        function () {
          secondaryImage.style.removeProperty("visibility");
        },
        { once: true }
      );
      secondaryImage.style.visibility = "hidden";
      secondaryImage.loading = "eager";
      secondaryImage.srcset = secondaryImage.dataset.srcset;
      secondaryImage.src = secondaryImage.dataset.src;
      delete secondaryImage.dataset.srcset;
      delete secondaryImage.dataset.src;
    });
  }

  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections(),
    headerMainMenu = new theme.Sections();
    headerMainMenuSlider = new theme.Sections();

    sections.register("scrolling_bar", theme.scrollingText);
    sections.register("header", theme.headerSection);
    headerMainMenuSlider.register("header", theme.menuProductSlider);
    headerSearchModule.register("header", theme.headerSearch);
    headerCartModule.register("header", theme.CartDrawerActions);
    headerStickyModule.register("header", theme.headerSticky);
    headerMainMenu.register("header", theme.headerMainMenuModule);
    sections.register("footer", theme.footerSection, true);
    sections.register("slideShow", theme.SlideShow);
    sections.register("product-tab", theme.productTab, true);
    sections.register("collection-product", theme.collectionProduct, true);
    sections.register("product-slider", theme.collectionSlider, true);
    sections.register('accordion', theme.accordion, true);
    sections.register("lookbook", theme.lookbookSlider, true);
    sections.register("timeline", theme.timelineSlider, true);
    sections.register('blog', theme.blog, true);
    sections.register('ctrnmbr', theme.counter__Number, true);
  



  
});
